import { CSSProperties, ReactNode } from 'react';

import cn from 'classnames';

import styles from './InfiniteScroller.module.scss';

const baseClass = 'infinite-scroller';

interface Props {
  items: ReactNode[];
  className?: string;
  slideWidth?: string | number;
  slideHeight?: string | number;
  slideGap?: string | number;
  animationDuration?: number;
  backgroundColor?: string;
}

export const InfiniteScroller = ({
  items,
  className,
  slideWidth = 'clamp(150px, 20vw, 300px)',
  slideHeight,
  slideGap = '1vw',
  animationDuration = 8,
  backgroundColor = '#fff',
}: Props) => {
  const repeatedItems = [...items, ...items, ...items, ...items];

  return (
    <div
      className={cn(styles[`${baseClass}-wrapper`], className)}
      style={
        {
          '--slide-width': `${slideWidth}px`,
          '--slide-height': slideHeight !== undefined ? `${slideHeight}px` : 'auto',
          '--slide-gap': `${slideGap}px`,
          '--animation-duration': `${animationDuration}s`,
          '--background-color': backgroundColor,
          '--item-count': items.length,
          '--move-initial': `calc(-25% + ${slideGap}px)`,
          '--move-final': `calc(-50% + ${slideGap}px)`,
        } as CSSProperties
      }
    >
      <div className={styles[`${baseClass}-list`]}>
        {repeatedItems.map((item, idx) => (
          <div key={`${idx}`} className={styles[`${baseClass}-slide`]}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
